/* eslint-disable no-param-reassign */
import mitt from 'mitt';
import { createTPluginFactory } from '../../plate';
import { KEY_EMITTER } from '../../pluginKeys';

export const createEmitterPlugin = createTPluginFactory({
  key: KEY_EMITTER,
  withOverrides: (editor) => {
    editor.emitter = mitt();
    return editor;
  },
});
